export default {
	title: "ウォッチ",
	url: "watch",
	subtitle: "匿名化されたリサーチによる戦略ウォッチレポート：公開ソースへの照会前にプロジェクトのテーマは中立化されます。レポートはマクロ環境（PESTEL）、業界環境（ポーターの5つの力）、内部環境を、強いシグナルと弱いシグナルとともにカバーします。",
	current: "最新レポート",
	archive: "アーカイブ",
	context_tab: "コンテキスト",
	empty: "このプロジェクトのウォッチレポートはまだありません。",
	generated_on: "作成日",
	actions: {
		generate: "レポートを生成",
		generate_new: "新しいレポートを生成",
		generating: "生成中…（10分ほどかかります）",
		retry: "再試行",
		print: "印刷",
		delete: "このレポートを削除",
		delete_confirm: "このレポートを完全に削除しますか？"
	},
	steps: {
		anonymizing: "テーマの匿名化",
		researching: "調査と執筆",
		done: "レポート利用可能",
		elapsed: "{{minutes}}分経過"
	},
	messages: {
		failed: "生成に失敗しました",
		neutral_subject: "送信された匿名化テーマ",
		confirm_title: "匿名化ウォッチを開始しますか？",
		confirm_body: "プロジェクトのテーマは、公開ソースでの調査の前に匿名化されます。レポートの生成には10分ほどかかります。"
	}
};
